import moment from "moment";

export const formatAddWorkPayload = ({ workDetails, paymentDetails = {}, isPaid }) => {
  const hasOvertime = workDetails.overtimeHours && workDetails.overtimeRate;

  return {
    ...workDetails,
    date: dateWithCurrentTime(workDetails.date),
    wage: workDetails.isGroupWork ? 0 : Number(workDetails.wage),
    workerId: Number(workDetails.workerId),
    overtimeHours: !workDetails.isGroupWork && hasOvertime ? Number(workDetails.overtimeHours) : undefined,
    overtimeRate: !workDetails.isGroupWork && hasOvertime ? Number(workDetails.overtimeRate) : undefined,
    paidAmount: paymentDetails.paidAmount ? Number(paymentDetails.paidAmount) : undefined,
    fromAccountId: paymentDetails.fromAccountId ? Number(paymentDetails.fromAccountId) : undefined,
    isPaid,
    isGroupWork: workDetails.isGroupWork,
    particulars:
      workDetails.isGroupWork && workDetails.particulars
        ? workDetails.particulars.map((p) => ({
            particularId: p.particularId,
            name: p.name,
            rate: Number(p.rate),
            quantity: Number(p.quantity),
          }))
        : undefined,
  };
};

export const formatUpdateWorkPayload = (workDetails) => {
  const hasOvertime = workDetails.overtimeHours && Number(workDetails.overtimeHours) > 0;

  return {
    date: dateWithCurrentTime(workDetails.date),
    wage: workDetails.isGroupWork ? 0 : Number(workDetails.wage),
    // null (not undefined) so the PATCH explicitly clears previously saved overtime
    overtimeHours: !workDetails.isGroupWork && hasOvertime ? Number(workDetails.overtimeHours) : null,
    overtimeRate: !workDetails.isGroupWork && hasOvertime ? Number(workDetails.overtimeRate) : null,
    projectId: workDetails.projectId,
    taskId: workDetails.taskId,
    projectStageId: workDetails.projectStageId,
    description: workDetails.description,
    isGroupWork: workDetails.isGroupWork,
    particulars:
      workDetails.isGroupWork && workDetails.particulars
        ? workDetails.particulars.map((p) => ({
            particularId: p.particularId,
            name: p.name,
            rate: Number(p.rate),
            quantity: Number(p.quantity),
          }))
        : undefined,
  };
};

export const dateWithCurrentTime = (selectedDate) => {
  const now = moment.utc();

  return moment
    .utc(selectedDate)
    .set({
      hour: now.hour(),
      minute: now.minute(),
      second: now.second(),
      millisecond: now.millisecond(),
    })
    .toISOString();
};
